import { Keypair } from 'tokend-js-sdk'
import { accountsService } from '@api/accounts.service'
import { transactionsService } from '@api/transactions.service'
import { parseTransaction } from '@js/parsers/tx.parser'
import { Paginator } from '@js/helpers/paginator'
import { vuexTypes } from '../types'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'

function getInitialState () {
  return {
    lists: {},
    isInitialized: false,
    twoFactor: {
      showFactor: false,
      operation: () => {}
    }
  }
}

const state = getInitialState()

export const mutations = {
  SET_LOGGED_OUT_STATE (state) {
    Object.assign(state, getInitialState())
  },
  UPDATE_TX_LIST (state, tokenCodes) {
    [...tokenCodes, 'all'].forEach(code => {
      state.lists[code] = new Paginator({
        recordWrp: (record) => parseTransaction(record, code)
      })
    })
  },

  UPDATE_TX_LIST_ITEM (state, { code, paginator }) {
    const listKey = code === '' ? 'all' : code
    const lists = cloneDeep(state.lists)
    lists[listKey] = paginator
    state.lists = lists
  },

  SET_TX_LIST_INITIALIZED (state) {
    state.isInitialized = true
  },

  UPDATE_TWO_FACTOR_STATE (state, data) {
    state.twoFactor = data
  }
}

export const actions = {
  INIT_TX_LIST ({ commit, rootGetters }) {
    const tokenCodes = Object.keys(rootGetters.accountBalances)
    commit(vuexTypes.UPDATE_TX_LIST, tokenCodes)
    commit(vuexTypes.SET_TX_LIST_INITIALIZED)
  },

  async GET_TX_LIST ({ state, dispatch, commit }, {risk_type, code, type, hash, number, wallet, from, to, limit}) {
    if (!state.isInitialized) dispatch(vuexTypes.INIT_TX_LIST)

    let paginator
    let assetCode = code
    const listKey = code === '' ? 'all' : code

    if (state.lists[listKey]) {
      paginator = state.lists[listKey]
    } else {
      state.lists[listKey] = new Paginator({
        recordWrp: record => parseTransaction(record, listKey)
      })
      paginator = state.lists[listKey]
    }

    paginator.attachInitLoader(() => transactionsService.loadTransactionHistory({
      riskType: risk_type,
      tokenCode: assetCode || '',
      limit
    }))

    await paginator.init()
    commit(vuexTypes.UPDATE_TX_LIST_ITEM, { code: assetCode, paginator })
  },

  async GET_TX_LIST_SECOND ({ state, dispatch, commit }, {risk_type, code, type, hash, number, wallet, from, to}) {
    if (!state.isInitialized) dispatch(vuexTypes.INIT_TX_LIST)

    let paginator
    if (state.lists[code]) {
      paginator = state.lists[code]
    } else {
      state.lists[code] = new Paginator({
        recordWrp: record => parseTransaction(record, code)
      })
      paginator = state.lists[code]
    }

    paginator.attachInitLoader(() => transactionsService.loadTransactionHistory({
      riskType: risk_type,
      tokenCode: code,
      t: type,
      hash,
      number,
      wallet,
      from,
      to
    }))

    await paginator.init()
    commit(vuexTypes.UPDATE_TX_LIST_ITEM, { code, paginator })
  },

  async NEXT_TX_LIST ({ state, commit, dispatch }, tokenCode) {
    const paginator = state.lists[tokenCode]
    await paginator.next()
    commit(vuexTypes.UPDATE_TX_LIST_ITEM, paginator)
  },

  async UPDATE_TX_COUNTERPARTIES ({ commit }, transactions) {
    const counterparties = transactions
      .map(transaction => transaction.counterparty)
      .filter(counterparty => Keypair.isValidPublicKey(counterparty))

    const details = (await accountsService.loadMultipleAccountDetails(counterparties)).data('users')

    transactions.forEach(transaction => {
      transaction.counterparty = get(details, `[${transaction.counterparty}].email`) || transaction.counterparty
    })
  },

  SET_TWO_FACTOR_STATE ({ commit }, data) {
    commit(vuexTypes.UPDATE_TWO_FACTOR_STATE, data)
  }
}

export const getters = {
  transactions: state => state.lists,
  twoFactor: state => state.twoFactor
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/transactions.module.js